import Vuex from "vuex";
import localStoragePlugin from "./plugins/localStorage";
import auth from "./modules/auth";

export default Vuex.createStore({
  modules: { auth },
  plugins: [localStoragePlugin],
});
